$(function () {
    // JavaScript to be fired on all category pages
    $(window).scroll(function () {
      if($(this).scrollTop() > 600 && $(window).scrollTop() + $(window).height() < $(document).height() - 1260) {
        $('#back-to-top').fadeIn();
      } else {
        $('#back-to-top').fadeOut();
      }
    });
    // scroll body to 0px on click
    $('#back-to-top').click(function () {
      $('body,html').animate({
        scrollTop: 0,
      }, 600);
      return false;
    });
  });


// WEBPACK FOOTER //
// ./scripts/routes/backToTop.js